import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=14cfdb21&scoped=true"
import script from "./forgetpassword.vue?vue&type=script&lang=js"
export * from "./forgetpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cfdb21",
  null
  
)

export default component.exports